var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrakes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.936,
    height: 65.842,
    viewBox: "0 0 62.936 65.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "noun-brakes-1694471",
    transform: "translate(-7.508 -4.938)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4890",
    "data-name": "Group 4890",
    transform: "translate(7.508 4.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4889",
    "data-name": "Group 4889",
    transform: "translate(13.487 17.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2849",
    "data-name": "Path 2849",
    d: "M59.9,40.138A17.424,17.424,0,1,0,62.855,64.6,17.4,17.4,0,0,0,59.9,40.138ZM61.35,50.559h0A1.893,1.893,0,0,1,62.8,51a2.134,2.134,0,0,1,.724,1.337,1.893,1.893,0,0,1-.446,1.449,2.134,2.134,0,0,1-1.337.724,2.039,2.039,0,0,1-1.449-.446.055.055,0,0,1-.056-.056,2.134,2.134,0,0,1-.724-1.337A1.99,1.99,0,0,1,61.35,50.559Zm-2.731-8.8a2.776,2.776,0,1,1-3.9.446A2.86,2.86,0,0,1,58.62,41.754Zm-10.867-2.34a2,2,0,0,1,2.173,1.839h0a2,2,0,0,1-1.839,2.173,1.893,1.893,0,0,1-1.449-.446,1.976,1.976,0,0,1-.78-1.393,1.893,1.893,0,0,1,.446-1.449A2.571,2.571,0,0,1,47.753,39.413Zm-10.142,8.8a2.776,2.776,0,1,1,3.9-.446A2.756,2.756,0,0,1,37.611,48.218ZM37,57.023a2.039,2.039,0,0,1-1.449-.446.055.055,0,0,1-.056-.056,2.134,2.134,0,0,1-.724-1.337,1.893,1.893,0,0,1,.446-1.449,2.134,2.134,0,0,1,1.337-.724A1.893,1.893,0,0,1,38,53.456a2.134,2.134,0,0,1,.724,1.337A1.85,1.85,0,0,1,37,57.023Zm2.731,8.8a2.776,2.776,0,1,1,3.9-.446A2.86,2.86,0,0,1,39.729,65.828Zm4.681-5.907a7.737,7.737,0,1,1,10.867-1.282A7.72,7.72,0,0,1,44.41,59.921ZM50.6,68.168a2.039,2.039,0,0,1-1.449-.446.055.055,0,0,1-.056-.056,2.134,2.134,0,0,1-.724-1.337,1.893,1.893,0,0,1,.446-1.449,2.134,2.134,0,0,1,1.337-.724A1.893,1.893,0,0,1,51.6,64.6a2.134,2.134,0,0,1,.724,1.337h0a1.893,1.893,0,0,1-.446,1.449A1.573,1.573,0,0,1,50.6,68.168Zm6.743-4.458a2.776,2.776,0,1,1,3.9-.446A2.812,2.812,0,0,1,57.338,63.71Z",
    transform: "translate(-31.71 -36.41)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2850",
    "data-name": "Path 2850",
    d: "M89.379,31.164a1.326,1.326,0,0,1-.5-.724A25.289,25.289,0,0,0,68.036,14.056a1.824,1.824,0,0,1-1.282-.836,1.167,1.167,0,0,1,.056-1.337l5.127-6.52a1.211,1.211,0,0,1,1.226-.39A34.654,34.654,0,0,1,87.039,11.66a33.5,33.5,0,0,1,9.418,11.647,1.177,1.177,0,0,1-.111,1.282l-5.127,6.52a1.2,1.2,0,0,1-1.282.39A1.855,1.855,0,0,1,89.379,31.164Z",
    transform: "translate(-33.658 -4.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M67.966,32.044,65.96,34.608a2.352,2.352,0,0,1-2.452.78,4.22,4.22,0,0,1-1-.5,2.8,2.8,0,0,1-.892-1.226,24.125,24.125,0,0,0-19.894-15.6A2.742,2.742,0,0,1,39.6,16.608a2.259,2.259,0,0,1,.167-2.563l2.006-2.563A31.187,31.187,0,1,0,67.966,32.044ZM25.949,58.625A20.557,20.557,0,1,1,54.815,55.17,20.563,20.563,0,0,1,25.949,58.625Z",
    transform: "translate(-7.508 -7.769)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrakes);
export default __webpack_public_path__ + "static/media/brakes.9948ceab82e0f6b2b77ddeb3d9a4637f.svg";
export { ForwardRef as ReactComponent };